import { useStaticQuery, graphql } from "gatsby";

const useResourceArticles = () => {
  const allArticleData = useStaticQuery(graphql`
    query articleFilterQuery {
      # ebooks
      allSanityOttomotorsEbook(sort: { publishedDate: DESC }) {
        nodes {
          _id
          _type

          title

          slug {
            current
          }
          resourceTopics {
            topics
          }

          resourceLanguages {
            languages
          }
          publishedDate

          cardButtonText
          cardImage {
            altText
            asset {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }

      # case studies
      allSanityOttomotorsCaseStudy(sort: { publishedDate: DESC }) {
        nodes {
          _id
          _type

          title

          slug {
            current
          }
          resourceTopics {
            topics
          }

          resourceLanguages {
            languages
          }
          publishedDate

          cardButtonText
          cardImage {
            altText
            asset {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }

      # blog articles
      allSanityOttomotorsBlogArticle(sort: { publishedDate: DESC }) {
        nodes {
          _id
          _type

          title

          slug {
            current
          }
          resourceTopics {
            topics
          }

          resourceLanguages {
            languages
          }

          publishedDate

          cardButtonText
          cardImage {
            altText
            asset {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }

      # videos
      allSanityOttomotorsVideo(sort: { publishedDate: DESC }) {
        nodes {
          _id
          _type

          title

          slug {
            current
          }
          resourceTopics {
            topics
          }

          resourceLanguages {
            languages
          }

          publishedDate

          cardButtonText
          cardImage {
            altText
            asset {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }

      # webinars
      allSanityOttomotorsWebinar(sort: { publishedDate: DESC }) {
        nodes {
          _id
          _type

          title
          streamUrl

          slug {
            current
          }
          resourceTopics {
            topics
          }

          resourceLanguages {
            languages
          }

          publishedDate

          cardButtonText
          cardImage {
            altText
            asset {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }

      # white papers
      allSanityOttomotorsWhitePaper(sort: { publishedDate: DESC }) {
        nodes {
          _id
          _type

          title

          slug {
            current
          }
          resourceTopics {
            topics
          }

          resourceLanguages {
            languages
          }

          publishedDate

          cardButtonText
          cardImage {
            altText
            asset {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }

      # downloads
      allSanityOttomotorsDownload(sort: { publishedDate: DESC }) {
        nodes {
          _id
          _type

          title

          slug {
            current
          }
          resourceTopics {
            topics
          }

          resourceLanguages {
            languages
          }

          publishedDate

          cardButtonText
          cardImage {
            altText
            asset {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  `);

  const allArticles = allArticleData.allSanityOttomotorsWebinar.nodes
    .concat(allArticleData.allSanityOttomotorsVideo.nodes)
    .concat(allArticleData.allSanityOttomotorsBlogArticle.nodes)
    .concat(allArticleData.allSanityOttomotorsEbook.nodes)
    .concat(allArticleData.allSanityOttomotorsCaseStudy.nodes)
    .concat(allArticleData.allSanityOttomotorsWhitePaper.nodes)
    .concat(allArticleData.allSanityOttomotorsDownload.nodes)
    .sort((a, b) => {
      if (!a.publishedDate) return 1;
      if (!b.publishedDate) return -1;
      return b.publishedDate.localeCompare(a.publishedDate);
    });

  return allArticles;
};

export default useResourceArticles;
